import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { OperationTypePipe } from './operation-type.pipe';
import { CountryFlagPipe } from './country-flag.pipe';
import { OperationTypeBadgeComponent } from '../components/operation-type-badge/operation-type-badge.component';

@NgModule({
  declarations: [FilterPipe, SearchPipe, ShortNamePipe, OperationTypePipe, CountryFlagPipe, OperationTypeBadgeComponent],
  imports: [CommonModule],
  exports: [FilterPipe, SearchPipe, ShortNamePipe, OperationTypePipe, CountryFlagPipe, OperationTypeBadgeComponent]
})
export class PipeModule {}
